import { BroadcastTabChannelType } from "@/enums/enums";
import { SocketConnect } from "@/helper/notificationHelper";
import { GetAllTabs, GetTabIdFromSessionStorage, SetMasterTab } from "@/helper/tabHelper";

let tabChannel: BroadcastChannel | null = null;
export const SetTabChannel = () => {
  try {
    tabChannel = new BroadcastChannel("PeakAccountTab");

    tabChannel.onmessage = async (event) => {
      if (event.data) {
        let tabs = null;
        let tabId = null;
        switch (event.data.broadcastType) {
          case BroadcastTabChannelType.MasterTabClose:
            tabs = await GetAllTabs();
            tabId = GetTabIdFromSessionStorage();
            if (tabs && tabs.length > 0 && tabs[0].id == tabId) {
              SetMasterTab();
              SocketConnect();
            }
            break;
        }
      }
    };
  } catch {
    tabChannel = null;
    throw new Error("Your browser doesn't support BroadcastChannel");
  }
};

export const BroadcastTabChannelMasterTabClose = () => {
  if (tabChannel) {
    tabChannel.postMessage({
      broadcastType: BroadcastTabChannelType.MasterTabClose,
      request: null,
    });
  }
};

export const CheckBroadcastIsSupport = () => {
  return tabChannel !== null;
};
